import { faCircle } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "src/base-components/Icon";
import { Select } from "src/base-components/Select";
import {
  castColor,
  Color,
  COLORS_LIST,
  getColorClass,
} from "src/base-components/schemaKit/schemaColors";

const colorOptions = COLORS_LIST.map((color) => ({
  key: color,
  value: (
    <div className="w-4">
      <Icon color={getColorClass(color)} icon={faCircle} size="3xs" />
    </div>
  ),
}));

type ColorSelectorProps = {
  value: Color | null | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const ColorSelector: React.FC<ColorSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <Select
    dataLoc="color-selector"
    disabled={disabled}
    options={colorOptions}
    value={castColor(value)}
    fullWidth
    onChange={onChange}
  />
);
